const modules = {
    INSTRUCTIONS: 'education',
    MEASURES: 'provision',
    CONSTRUCTION_SITES: 'egb',
    ARCHIVE: 'archive',
};

export default modules;
